export const HOTSPOT_DIAMETER = 30
